import React from "react";
import { RiCloseLine } from "react-icons/ri";
import Badge from "UpdatedFeatures/Badge";

const ViewArrivageDetailsModal = ({ open, setOpen, selectedArrivage }) => {
  if (!open || !selectedArrivage) return null;
  console.log(selectedArrivage)
  const formatDate = (dateString) => {
    if (!dateString) return 'Non spécifié';

    const date = String(dateString);
    const year = date.substring(0, 4);
    const month = date.substring(4, 6);
    const day = date.substring(6, 8);
    return `${year}/${month}/${day}`;
  };

  return (
    <div
      className="fixed inset-0 z-50"
      style={{ zIndex: 9991, overflow: "auto" }}
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-75"
        aria-hidden="true"
        onClick={() => setOpen(false)}
      />

      {/* Modal Content */}
      <div className="flex items-center justify-center min-h-screen p-4">
        <div
          className="relative w-full max-w-3xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex justify-between items-center p-6 bg-[#b269ae] border-b border-gray-500/30">
            <h3 id="modal-title" className="text-lg font-medium leading-6 text-white">
              Détails de l'Arrivage
            </h3>
            <button
              type="button"
              className="inline-flex items-center justify-center p-1.5 text-white hover:text-gray-200"
              onClick={() => setOpen(false)}
            >
              <RiCloseLine className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>

          <div className="p-6">
            {/* Arrivage Header Information */}
            <div className="bg-gray-50 p-4 rounded-lg mb-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <h4 className="text-sm font-medium text-gray-500">ID d'arrivage</h4>
                  <p className="font-semibold text-lg">{selectedArrivage.id}</p>
                </div>
                <div>
                  <h4 className="text-sm font-medium text-gray-500">Statut</h4>
                  <Badge status={selectedArrivage.status} type="arrivage" />
                </div>
                <div>
                  <h4 className="text-sm font-medium text-gray-500">Date de création</h4>
                  <p>{formatDate(selectedArrivage.date_creation)}</p>
                </div>
                <div>
                  <h4 className="text-sm font-medium text-gray-500">Date d'arrivage</h4>
                  <p>{selectedArrivage.date_arrivage}</p>
                </div>
                <div>
                  <h4 className="text-sm font-medium text-gray-500">Fournisseur</h4>
                  <p className="font-medium">{selectedArrivage.provider?.company_name}</p>
                </div>
                <div>
                  <h4 className="text-sm font-medium text-gray-500">Nombre de produits</h4>
                  <p className="font-medium">{selectedArrivage.products?.length || 0}</p>
                </div>
              </div>
            </div>

            {/* Products Section */}
            <h4 className="text-md font-semibold text-gray-800 mb-4 pb-2 border-b">
              Produits ({selectedArrivage.products?.length || 0})
            </h4>

            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg mb-6">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                    <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Produit</th>
                    <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Quantité</th>
                    <th className="py-3 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Statut</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {selectedArrivage.products?.map(product => (
                    <tr key={product.id} className="hover:bg-gray-50">
                      <td className="py-3 px-4 whitespace-nowrap">{product.id}</td>
                      <td className="py-3 px-4">
                        <div className="flex items-center">
                          {product.image && (
                            <img
                              src={product.image}
                              alt={product.title}
                              className="w-8 h-8 rounded-full mr-2 object-cover"
                            />
                          )}
                          <div>
                            <div className="font-medium text-gray-900">{product.title}</div>
                            {product.reference && (
                              <div className="text-xs text-gray-500">Ref: {product.reference}</div>
                            )}
                          </div>
                        </div>
                      </td>
                      <td className="py-3 px-4">{product.pivot.received_quantity ? product.pivot.received_quantity : product.pivot.kdQuantity}</td>
                      <td className="py-3 px-4">
                        {product.pivot?.status === 1 ? (
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                            Réceptionné
                          </span>
                        ) : (
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">
                            En attente
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>


            {/* Footer */}
            <div className="mt-6 flex justify-end">
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewArrivageDetailsModal; 